import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { PortfolioEstimateProvider } from "./context/PortfolioEstimateContext";
import { CurrencySelectionProvider } from "./context/CurrencySelectionContext";
import Auth0ProviderWithNavigate from "./auth/Auth0ProviderWithNavigate";
import { queryClient } from "./queryClient";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <BrowserRouter>
    <Auth0ProviderWithNavigate>
      <AuthProvider>
        <QueryClientProvider client={queryClient}>
          <CurrencySelectionProvider>
            <PortfolioEstimateProvider>
              <App />
            </PortfolioEstimateProvider>
          </CurrencySelectionProvider>
        </QueryClientProvider>
      </AuthProvider>
    </Auth0ProviderWithNavigate>
  </BrowserRouter>
);

reportWebVitals();
